// SUP-349 — replaces vue-svgicon with an in-house inline-SVG component (GwbIcon.vue +
// icon-markup.js). See ui/README.md "Icons".
import GwbIcon from './GwbIcon.vue';
import './icons.scss';

export default function install(Vue) {
  Vue.component('gwb-icon', GwbIcon);
}
